import styled from 'styled-components';

const LanguageSwitcherStyle = styled.div`
	--selectedLangArrowDistance: var(--sp1x);

	z-index: 11;

	.selected-lang-wrap {
		display: flex;
		align-items: center;
		gap: var(--selectedLangArrowDistance);
		background-color: transparent;
		z-index: 111;
		position: relative;
	}

	.languages-wrapper {
		position: absolute;
		top: calc(100% - var(--headerPadTB));
		/* padding: var(--desktopDropdownPad); */
		padding: calc(var(--desktopDropdownPad) - var(--desktopDropdownItemPad)) var(--desktopDropdownPad);
		transform: translateX(calc((var(--desktopDropdownPad)) * -1));
		border-radius: var(--desktopDropdownBorderRadius);
		background-color: var(--white1000);
		border: 1px solid var(--gray100);
		pointer-events: none;
		user-select: none;
		will-change: opacity;
		opacity: 0;
		transition: opacity 0.1s ease-out;
	}

	.languages-inner-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
		/* gap: calc(var(--desktopDropdownItemsGap) - var(--desktopDropdownItemPad)); */

		&:before {
			content: '';
			position: absolute;
			bottom: 100%;
			width: calc(100% + var(--desktopDropdownPad));
			height: calc(100% - var(--desktopDropdownPad));
			display: none;
		}
	}

	.selected-lang-icon {
		font-size: 14px;
		will-change: transform;
		transition: transform var(--trTime) ease-out;
	}

	.lang-item {
		position: relative;
		padding: var(--desktopDropdownItemPad) 0;
		z-index: 11;
	}

	.lang-item-link {
		position: relative;

		&:before {
			content: '';
			position: absolute;
			left: calc(-1 * var(--desktopDropdownItemPad));
			width: calc(100% + var(--desktopDropdownItemPad) * 2);
			height: 100%;
			border-radius: var(--desktopDropdownItemBorderRadius);
			overflow: hidden;
			transition: background-color var(--trTime) ease-out;
		}
	}

	/* //! Hover */
	@media (pointer: fine) {
		@media (hover: hover) {
			&.hover-version {
				&:hover {
					.languages-wrapper {
						opacity: 1;
						pointer-events: all;
					}

					.selected-lang-icon {
						transform: rotate(180deg);
					}

					.languages-inner-wrapper {
						&:before {
							display: block;
						}
					}
				}
			}

			.lang-item-link {
				&:hover {
					&:before {
						background-color: var(--gray100);
					}
				}
			}
		}
	}

	&.open {
		.languages-wrapper {
			opacity: 1;
			pointer-events: all;
		}

		.selected-lang-icon {
			transform: rotate(180deg);
		}

		.languages-inner-wrapper {
			&:before {
				display: block;
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default LanguageSwitcherStyle;
